import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { FacetBase } from "../../models/facet-base/facet-base";

/**
 * Get the url param name for a given facet ID/ field name.
 *
 * @param facetId - The ID of the facet that you want the url param for.
 * @param facets - The list of facets to to search with the facetId.
 * @returns If the facetId exists in the facet list return the url param otherwise return empty string.
 */
export const getFacetUrlParamName = (
	facetId: string,
	facets: FacetBase[],
): string => {
	if (isStringEmpty(facetId)) {
		return "";
	}
	if (facets === null || facets === undefined || facets.length === 0) {
		return "";
	}

	for (let index = 0; index < facets.length; index++) {
		const facet = facets[index];

		if (facet.fieldName === facetId) {
			return facet.urlParamName;
		}
	}

	return "";
};
